import { BaseService } from "./BaseService";
import { MenuService } from "./MenuService";
import { Configuration } from "Configuration";
import { Navigation, CoreContext } from "Core";
import { NotificationTypes } from "Enums";
import { TextBlockService, CommandService } from "Service";
import { IStartPageRequestParameter } from "Entities";

/**
 * User services.
 * 
 * Service which provides access to user data and functionality.
 * @hidden
 */
export class UserService extends BaseService {

    private textBlockService: TextBlockService;
    private menuService: MenuService;

    /**
     * Create a new UserService.
     * @param textBlockService
     * @param menuService 
     */
    constructor(textBlockService: TextBlockService, menuService: MenuService) {
        super();
        this.textBlockService = textBlockService;
        this.menuService = menuService;
    }
    
    /**
     * Sets currently visit website as startpage.
     */
    public async setStartPage(): Promise<void> {
        let baseUrlLength = $("base").attr("href").length; // /DMS_Test/ or /
        let startPage = document.location.pathname + document.location.search; // f.i: /DMS_Test/DMS/tst_ctl...
        startPage = startPage.slice(baseUrlLength, startPage.length); // f.i: DMS/tst_ctl..
        let execute = await Navigation.confirmAsync(this.textBlockService.get("confirmSetStartPage", "userdata"), " ");
        if (!execute) {
            return;
        }
        let parameter = <IStartPageRequestParameter>CommandService.getPageTokenParameter();
        parameter.StartPage = "~/" + startPage;

        await this.post(Configuration.baseUrl + "user/startpage", parameter); // add /
        Navigation.notify("StartPage changed!", NotificationTypes.Success);
    }

    /**
     * Log off the current user.
     */
    public logout(): void {
        this.menuService.clearCache();
        Navigation.navigate("/Account/LogOffGet");
    }

    /**
     * Open the textblock page for current page.
     */
    public openTextBlocks(): void {
        Navigation.openWindow("/DMS/int_TextBlock?pagemode=dialog&category=" + CoreContext.Instance.initialTextBlockCategory.toLowerCase(), "width=1620,height=909,resizable=yes");
    }
}